import axios from "axios";
import React, { useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  setOrderId,
  setPaytmDataInStore,
} from "../../../../../../../redux/payment_gateway/action";
import { url_301 } from "../../../../../../../custom_utilities/api_services";
import {
  extractOrderId,
  savePendingHandbookOrderId,
} from "../../../../../../../custom_utilities/paytm_payment/paytmHandbookHelpers";
import "./PaytmHandbook.scss";
import EmailUpdateModal from "../../../../../user_edit_profile/user_edit_profile_content_component/update_email/EmailUpdateModal";

const PaytmHandbook = (props) => {
  const {
    packageDetails,
    handleBookDetails,
    token,
    tokenType,
    paymentAction,
    setPaytmDataInStore,
    userData,
    buttonText,
    buttonClass,
    is_amrit,
  } = props;

  const { name, mobile, email, address, user_id } = userData || {};

  const [emailStatus, setEmailStatus] = useState({
    showEmailModal: false,
    emailUpdated: false,
  });
  const [isInitiating, setIsInitiating] = useState(false);
  const history = useHistory();

  const handleOpen = () => {
    setEmailStatus((prevState) => ({
      ...prevState,
      showEmailModal: true,
    }));
  };

  const handleClose = () => {
    setEmailStatus((prevState) => ({
      ...prevState,
      showEmailModal: false,
    }));
  };

  const navigateToHandbookPaymentPage = (paytmData) => {
    const orderIdValue = extractOrderId(paytmData);
    if (!orderIdValue) return false;

    setPaytmDataInStore(paytmData);
    savePendingHandbookOrderId(orderIdValue);
    history.push(
      `/handbook_payment_gateway?order_id=${encodeURIComponent(
        orderIdValue
      )}&await_payment=1`
    );
    return true;
  };

  const initiateHandbookPaytm = async () => {
    if (!user_id || !handleBookDetails) return null;

    const productId = handleBookDetails?.product_id;
    if (!productId) {
      return null;
    }

    const fromCartValue = handleBookDetails?.from_cart === true ? "true" : "false";

    const payload = {
      user_id,
      product_id: productId,
      price: handleBookDetails?.price,
      discount: handleBookDetails?.discount || 0,
      coupon_discount: handleBookDetails?.coupon_discount || 0,
      shipping_charge: handleBookDetails?.shipping_charge || 0,
      total_price:
        handleBookDetails?.total_price || handleBookDetails?.discounted_price,
      from_cart: fromCartValue,
      coins_count: handleBookDetails?.coins_count || "0",
      is_referal: handleBookDetails?.is_referal || 0,
    };

    const response = await axios.post(url_301, payload);

    if (response.data.status === 200) {
      const responseData = response.data?.data || response.data;
      const orderIdValue = extractOrderId(responseData);
      paymentAction(orderIdValue);
      return responseData;
    }

    return null;
  };

  const handleProfileData = (e) => {
    if (is_amrit || packageDetails?.is_subscribe) {
      e?.stopPropagation?.();
      e?.preventDefault?.();
      return true;
    }

    const fieldsToCheck = [
      { field: name, label: "name" },
      { field: mobile, label: "mobile number" },
      { field: email, label: "email" },
      { field: address?.state, label: "state" },
      { field: address?.city, label: "city" },
    ];

    const updatedFields = fieldsToCheck.filter(
      (element) => element.field === "" || element.field === null
    );

    if (updatedFields.length > 0) {
      const missingFields = updatedFields.map((item) => item.label).join(", ");
      if (missingFields.includes("email")) {
        handleOpen();
        return false;
      }
    }

    window.onbeforeunload = null;
    return true;
  };

  const handlePayNow = async (e) => {
    if (!handleProfileData(e)) return;
    if (isInitiating) return;

    setIsInitiating(true);
    try {
      const paytmData = await initiateHandbookPaytm();
      if (paytmData) navigateToHandbookPaymentPage(paytmData);
    } catch (err) {
    } finally {
      setIsInitiating(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className={buttonClass || "store_paynow"}
        onClick={handlePayNow}
        disabled={isInitiating}
      >
        {buttonText || "Proceed to Pay"}
      </button>

      {emailStatus?.showEmailModal && (
        <EmailUpdateModal
          isEmailModalOpen={emailStatus.showEmailModal}
          closeEmailModal={handleClose}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  token: state.auth.authToken,
  tokenType: state.auth.tokenType,
  userData: state.auth.user,
  user_id: state.auth.user.user_id,
  is_amrit: state.auth.user.is_amrit,
});

const mapDispatchToProps = (dispatch) => ({
  paymentAction: (payload) => {
    dispatch(setOrderId(payload));
  },
  setPaytmDataInStore: (payload) => {
    dispatch(setPaytmDataInStore(payload));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PaytmHandbook);

